module.exports = "/img/automation/One-icon-active.png?7a83a522dce19e49eb54a4df47230a59";